import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.94902 0.000325768H0.651442C0.288132 0.000325768 0 0.29817 0 0.687584C0 1.077 0.288132 1.38266 0.651442 1.38266H3.66118C3.90807 1.38266 4.08621 1.50486 4.1959 1.75676L8.70715 13.0605C8.96076 13.7018 9.37906 14 10.0168 14H13.3553C13.7122 14 14 13.6943 14 13.3124C14 12.9305 13.7119 12.6173 13.3556 12.6173H10.3251C10.0443 12.6173 9.87254 12.503 9.76285 12.2507L5.26536 0.955123C5.03222 0.359434 4.54576 0.000325768 3.94902 0.000325768ZM13.3553 0.000325768H8.9201C8.5565 0.000325768 8.27539 0.29035 8.27539 0.679763C8.27539 1.0695 8.5565 1.36735 8.91981 1.36735H13.3559C13.7192 1.36735 13.9936 1.0695 13.9936 0.679763C13.9936 0.29035 13.7192 0 13.3559 0L13.3553 0.000325768Z",
      fill: "#EBEBEB"
    }, null, -1)
  ]))]))
}
export default { render: render }